import { useState, useEffect } from 'react';
import { projectFirestore, timestamp } from '../firebase/config';

// البيانات الأولية للأقسام الحالية — تُستخدم مرة واحدة لتهيئة Firestore
const SEED_SECTIONS = [
    { key: 'images', label: 'المعرض', order: 0, enabled: true, defaultCover: '' },
    { key: 'art', label: 'الفنون', order: 1, enabled: true, defaultCover: './img/art.jpg' },
    { key: 'nat', label: 'الطبيعة', order: 2, enabled: true, defaultCover: './img/nat.jpg' },
    { key: 'fb', label: 'فلاش باك', order: 3, enabled: true, defaultCover: './img/fb.jpg' },
    { key: 'pano', label: 'بانوراما اكتوبر', order: 4, enabled: true, defaultCover: './img/pano.jpg' },
    { key: 'ath', label: 'الاثار', order: 5, enabled: true, defaultCover: './img/ath.jpg' },
    { key: 'hand', label: 'الحرف اليدوية', order: 6, enabled: true, defaultCover: './img/hand.jpg' },
    { key: 'hlifeBefore', label: 'حياة كريمة قبل', order: 7, enabled: true, defaultCover: './img/hlife.jpg' },
    { key: 'hlifeBet', label: 'حياة كريمة اثناء', order: 8, enabled: true, defaultCover: '' },
    { key: 'hlifeAfter', label: 'حياة كريمة بعد', order: 9, enabled: true, defaultCover: '' },
    { key: 'green-project', label: 'الريادة الخضراء', order: 10, enabled: true, defaultCover: '' },
    { key: 'edu-achievements', label: 'انجازات التربية', order: 11, enabled: true, defaultCover: '' },
    { key: 'quality-innovations', label: 'الجودة', order: 12, enabled: true, defaultCover: '' },
    { key: 'alliance-development', label: 'التحالف والتنمية', order: 13, enabled: true, defaultCover: '' },
    { key: 'innovation-entrepreneurship', label: 'الابتكار وريادة', order: 14, enabled: true, defaultCover: '' },
    { key: 'egyptian-museum', label: 'المتحف المصري', order: 15, enabled: true, defaultCover: '' },
];

let seedingInProgress = false;

const useSections = () => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = projectFirestore.collection('sections')
            .orderBy('order', 'asc')
            .onSnapshot(async (snap) => {
                if (snap.empty && !seedingInProgress) {
                    // تهيئة أولية — إنشاء الأقسام الافتراضية
                    seedingInProgress = true;
                    const batch = projectFirestore.batch();
                    SEED_SECTIONS.forEach(s => {
                        const ref = projectFirestore.collection('sections').doc(s.key);
                        batch.set(ref, { ...s, createdAt: timestamp() });
                    });
                    try {
                        await batch.commit();
                    } catch (err) {
                        console.error('Error seeding sections:', err);
                    }
                    seedingInProgress = false;
                    return; // سيتم اطلاق onSnapshot مرة أخرى بعد الإضافة
                }

                const data = [];
                snap.forEach(doc => {
                    data.push({ ...doc.data(), id: doc.id });
                });
                setSections(data);
                setLoading(false);
            }, (error) => {
                console.error('Sections listener error:', error);
                setLoading(false);
            });

        return () => unsub();
    }, []);

    return { sections, loading };
};

export default useSections;
